import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const GoogleCircle24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.googleFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12 1c6.07 0 11 4.93 11 11s-4.93 11-11 11S1 18.07 1 12 5.93 1 12 1zm-.143 6.313a4.54 4.54 0 00-3.959 2.312l-.102.191-.109.234a4.54 4.54 0 000 3.613l.11.234.101.19a4.54 4.54 0 003.959 2.313c1.226 0 2.255-.407 3.006-1.1.86-.792 1.355-1.957 1.355-3.34a5.22 5.22 0 00-.082-.93h-4.28v1.758h2.446l-.043.186a2.079 2.079 0 01-.71 1.072l-.154.113-.158.097c-.38.214-.846.337-1.38.337-1.184 0-2.185-.8-2.543-1.873a2.731 2.731 0 01-.142-.863c0-.3.051-.591.142-.864.358-1.074 1.36-1.873 2.543-1.873.667 0 1.266.23 1.736.68l1.304-1.304-.173-.152a4.365 4.365 0 00-2.867-1.031z"
      fillRule="evenodd"
    />
  </svg>
);

export default GoogleCircle24;
